import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { observer, inject } from 'mobx-react'
import { tranzila } from '@services/api'
import { Row, Col, Button, Form, InputNumber, Icon, Select, Modal } from 'antd'
import { rtlInputNumber } from './edit-sub-sto.scss'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
class EditSubStoDataPopup extends Component<any, any> {
    state = {
        loading: false,
        responseTitle: ''
    }

    async componentDidMount() {
        this.resetState()
    }

    componentDidUpdate(prevProps) {
        // reset when modal opens or closes
        if (prevProps.visible !== this.props.visible) {
            this.resetState()
            this.props.form.resetFields()
        }
    }

    resetState = () => {
        this.setState({ loading: false, responseTitle: '' })
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (err) return
            this.setState({ loading: true }, async () => {
                const { sto_data = {}, addStoDataToState } = this.props
                const { user_sub_id = '', sto_id } = sto_data
                tranzila
                    .editSubStoData({ ...values, user_sub_id })
                    .then(({ status }) => {
                        if (status === 200) {
                            this.setState({
                                loading: false,
                                responseTitle: '✅ המערכת עודכנה בהצלחה'
                            })
                            addStoDataToState(sto_id, values.stoId)
                            return
                        }
                        this.setState({
                            loading: false,
                            responseTitle: '❌ המערכת לא עודכנה'
                        })
                    })
                    .catch(err => {
                        console.error(err.response && err.response.data)
                        this.setState({
                            loading: false,
                            responseTitle: '❌ המערכת לא עודכנה'
                        })
                    })
            })
        })
    }

    validateIds = (rule, value, callback) => {
        const { getFieldValue } = this.props.form
        const stoId = getFieldValue('stoId')
        stoId ? callback() : callback('יש למלא שדה')
    }

    handleSwitchChange = value => {
        const { responseTitle } = this.state
        if (responseTitle) this.setState({ responseTitle: '' })
    }

    handleClose = () => {
        if (this.state.loading) return
        this.resetState()
        this.props.form.resetFields()
        this.props.onClose()
    }

    render() {
        const { Item: FormItem } = Form
        const {
            authStore: { roles }
        } = this.props
        const { handleSubmit, validateIds, handleSwitchChange } = this

        const { loading, responseTitle } = this.state
        const { getFieldDecorator } = this.props.form
        const { visible, sto_data = {} } = this.props
        const { sto_id = '', terminal_name = 'mediwho1tok', sto_status = 'active', client = {} } = sto_data
        const { name = '' } = client
        const hasAcceptedRole = roles.includes('admin') || roles.includes('money')

        return (
            <Modal
                width={'500px'}
                onCancel={this.handleClose}
                closeIcon={
                    <span style={{ fontSize: 24, lineHeight: 1, display: loading ? 'none' : 'inline-block' }}>×</span>
                }
                visible={visible}
                maskClosable={false}
                title={`לשמור נתוני חיוב במערכת (${name})`}
                footer={responseTitle || null}
            >
                <Form onSubmit={handleSubmit} layout="vertical">
                    <Row gutter={24} justify={'center'} type={'flex'}>
                        <Col span={8}>
                            <FormItem label={'מזהה חיוב'} labelCol={{ style: { textAlign: 'right' } }}>
                                {getFieldDecorator('stoId', {
                                    rules: [{ validator: validateIds, required: true }],
                                    initialValue: sto_id
                                })(
                                    <InputNumber
                                        className={rtlInputNumber}
                                        placeholder="הקלד מזהה"
                                        parser={value => value.replace(/[^\d]/g, '')}
                                        onChange={handleSwitchChange}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label="מסוף" labelCol={{ style: { textAlign: 'right' } }}>
                                {getFieldDecorator('terminalName', {
                                    initialValue: terminal_name
                                })(
                                    <Select onChange={handleSwitchChange} style={{ width: '100%' }}>
                                        <Select.Option value="mediwho1tok">אשראי</Select.Option>
                                        <Select.Option value="mediwhobk">ה״וק</Select.Option>
                                        {/*
                                            ISHPUZPLUS-PENDING: terminal not yet in Tranzila
                                            <Select.Option value="ishpuzplus">אשראי (מסוף אשפוז)</Select.Option>
                                        */}
                                        {terminal_name === 'mediwhotok' && (
                                            <Select.Option value="mediwhotok">אשראי (מסוף ישן)</Select.Option>
                                        )}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label="סטטוס" labelCol={{ style: { textAlign: 'right' } }}>
                                {getFieldDecorator('status', {
                                    initialValue: sto_status
                                })(
                                    <Select onChange={handleSwitchChange} style={{ width: '100%' }}>
                                        <Select.Option value="active">פעיל</Select.Option>
                                        <Select.Option value="inactive">לא פעיל</Select.Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Row gutter={24} justify={'center'} type={'flex'}>
                            <Button type="primary" htmlType="submit" disabled={!hasAcceptedRole || loading}>
                                {loading ? <Icon type="loading" /> : <span>שלח</span>}
                            </Button>
                        </Row>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default withRouter(Form.create()(EditSubStoDataPopup))
